<div class="container-fluid">
    <div class="row m-0 p-1">
        <div class="col-lg-12 m-0 p-1">
            <div class="bg-white rounded shadow">
                <div class="row m-0 p-0 ">
                    <div class="col-lg-3 d-flex my-auto">
                        <div class="custom-search ">
                            <input type="filter" class="custom-search-input" placeholder="Search for" autocomplete="off" tabindex="1" (input)="onSearchChange($event.target.value)">
                        </div>
  
                    </div>
                    <div class="col-lg-6 d-flex">
                        <div class="form-group">
                            <label >Asset Type:</label>
                            <select #assettype class="custom-select round dropdown_W" formControlName="asset_type_id" (change)="onAssetTypeChange(assettype.value)">
                              <option value="">Select Asset Type</option>
                              <option *ngFor="let data of AssetsDataLists" [value]="data.id">{{data.name}}</option>
                            </select>
                        </div>
        
                        <div class="form-group">
                            <label >Creative:</label>
                            <select #creative  class="custom-select round dropdown_W" formControlName="creative_id" (change)="onCreativeChange(creative.value)">
                            <option value="">Select Creative</option>
                            <option *ngFor="let data of CreativeDataLists" [value]="data.id">{{data.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-3 d-flex my-auto">
  
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row m-0 p-1">     
        <div class="col-lg-4 m-0 p-1">
            <div class="bg-white rounded shadow pb-3">
                <div class="p-4" *ngIf="isShowTab">
                    <!-- Rounded tabs -->
                    <ul id="myTab" role="tablist" class="nav nav-tabs nav-pills flex-column flex-sm-row text-center bg-light border-0 rounded-nav">
                        <li class="nav-item flex-sm-fill">
                        <a id="state-tab" data-toggle="tab" href="#state" role="tab" aria-controls="state" aria-selected="true" class="nav-link border-0 text-uppercase font-weight-bold active">Region</a>
                        </li>
                        <li class="nav-item flex-sm-fill">
                        <a id="showroom-tab" data-toggle="tab" href="#showroom" role="tab" aria-controls="showroom" aria-selected="false" class="nav-link border-0 text-uppercase font-weight-bold">Showroom</a>
                        </li>
                    </ul>            
                    <!-- End rounded tabs -->
                </div>
                <div id="myTabContent" class="tab-content"  *ngIf="isShowTab">
                    <div id="state" role="tabpanel" aria-labelledby="state-tab" class="tab-pane fade px-3 show active">
                        <div class="row mp-0">
                            <div class="col-6 my-1 mx-auto" *ngFor="let data of RegionDataLists;let i=index">
                                <div class="box p-1 pointer" (click)="onRegionClick(data.id,data.name)">
                                    <img class="img-fluid z-depth-1"
                                    onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"

                                    alt="">
                                    <p class="text-center text-black font-weight-bold text-uppercase  m-0 p-2 ">{{data.name}}</p>
                                </div>
                                </div>
                        </div>
                    </div>

                    <div id="showroom" role="tabpanel" aria-labelledby="showroom-tab" class="tab-pane fade px-3">
                        <div class="row mp-0">
                            <div class="col-6 my-1 mx-auto" *ngFor="let data of ShowroomDataLists;let i=index">
                                <div class="box p-1 pointer" (click)="showInstoreData(data.region_id,data.regionName,data.id,data.name)">
                                    <img class="img-fluid z-depth-1"
                                    onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"

                                    alt="">
                                    <p class="text-center text-black font-weight-bold text-uppercase m-0 p-2 ">{{data.name}}</p>
                                </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class=""  *ngIf="!isShowTab">
                    <div class="title-header d-flex">
                        <div class="text-left col-10 my-auto">
                            <span class="text-muted">Region : </span><h5 class="m-0 p-0">{{selectedRegion}}</h5>
                        </div>
                        <div class="text-right col-2 my-auto">
                            <div class="back pointer">
                                <a (click)="onBackClick();"><i class="fa fa-long-arrow-left fa-lg"></i></a>
                            </div>
                        </div>
                       
                    </div>
                    <div class="row mp-0">
                        <div class="col-6 my-1 mx-auto" *ngFor="let data of f_Region_Showroom_list;let i=index">
                            <div class="box p-1 pointer" (click)="showInstoreData(data.region_id,data.regionName,data.id,data.name)">
                                <img class="img-fluid z-depth-1"
                                onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"

                                alt="">
                                <p class="text-center text-black font-weight-bold text-uppercase  m-0 p-2 ">{{data.name}}</p>
                            </div>
                            </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="col-lg-8 m-0 p-1">
            <div class="bg-white rounded shadow">
                <div class="title-header"><h5 class="mp-0">Hoardings - Map</h5></div>
                <div #gmap class="map-placeholder"> </div>
                <div class="row m-0 p-0 w-100" *ngIf="selHoarding">
                        <div class="col-md-6 m-0 p-1">
                            <div class="text-center shadow">
                                    <img class="w-100 p-3" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{selHoarding.image}}"   onerror="this.src='/assets/grt.svg'" >
                            </div>
                        </div>
                        <div class="col-md-6 m-0 p-1">
                            <div class="details-info px-3">
                                <div class="form-group row">
                                    <div class="col-4"><p>Hoarding Name  : </p></div>
                                    <div class="col-8"><p>{{selHoarding.name}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Region : </p></div>
                                    <div class="col-8"><p>{{selHoarding.regionName}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Showroom : </p></div>
                                    <div class="col-8"><p>{{selHoarding.showroomName}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Area : </p></div>
                                    <div class="col-8"><p>{{selHoarding.address}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Asset Type  : </p></div>
                                    <div class="col-8"><p>{{selHoarding.assetTypeName}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Creative  : </p></div>
                                    <div class="col-8"><p>{{selHoarding.creativeName}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Size  : </p></div>
                                    <div class="col-8">
                                        <p class="mp-0">Height :  {{selHoarding.size_w}}</p>
                                        <p class="mp-0">Width  :  {{selHoarding.size_h}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Square Feet : </p></div>
                                    <div class="col-8"><p>{{selHoarding.square_feet}} sq.ft</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Cost : </p></div>
                                    <div class="col-8"><p>{{selHoarding.cost| currency:'INR'}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Installation Date  : </p></div>
                                    <div class="col-8"><p>{{selHoarding.install_date}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Expiry Date  : </p></div>
                                    <div class="col-8"><p>{{selHoarding.expiry_date}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Particulars  : </p></div>
                                    <div class="col-8"><p>{{selHoarding.particulars}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Vendor  : </p></div>
                                    <div class="col-8"><p>{{selHoarding.vendorName}}</p></div>
                                </div>

                            </div>  
                        </div>
                </div>
               

            </div>
           
        </div>
    </div>
         
</div>
